module.exports = __webpack_public_path__ + "img/区域矩形-默认.bc9a2d9b.png";